import { authPost } from './authMiddleware';

export const postCompanyList = (data) => {
    return authPost('/api/Company', data);
}